import { render, staticRenderFns } from "./UpProxy.vue?vue&type=template&id=bf14731a&scoped=true&slot-scope=scope&"
import script from "./UpProxy.vue?vue&type=script&lang=js&"
export * from "./UpProxy.vue?vue&type=script&lang=js&"
import style0 from "./UpProxy.vue?vue&type=style&index=0&id=bf14731a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf14731a",
  null
  
)

export default component.exports